import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import createClass from 'create-react-class';
var propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  style: PropTypes.any,
  destroyInactiveTabPane: PropTypes.bool,
  forceRender: PropTypes.bool,
  placeholder: PropTypes.node
};
var defaultProps = {
  placeholder: null
};

var TabPane = /*#__PURE__*/function (_Component) {
  _inherits(TabPane, _Component);

  var _super = _createSuper(TabPane);

  function TabPane() {
    _classCallCheck(this, TabPane);

    return _super.apply(this, arguments);
  }

  _createClass(TabPane, [{
    key: "render",
    value: function render() {
      var _classnames;

      var props = this.props;
      var className = props.className,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          active = props.active,
          forceRender = props.forceRender;
      this._isActived = this._isActived || active;
      var clsPrefix = "".concat(props.rootclsPrefix, "-tabpane");
      var cls = classnames((_classnames = {}, _defineProperty(_classnames, clsPrefix, 1), _defineProperty(_classnames, "".concat(clsPrefix, "-inactive"), !active), _defineProperty(_classnames, "".concat(clsPrefix, "-active"), active), _defineProperty(_classnames, className, className), _classnames));
      var isRender = destroyInactiveTabPane ? active : this._isActived;
      return /*#__PURE__*/React.createElement("div", {
        style: props.style,
        role: "tabpanel",
        "aria-hidden": props.active ? "false" : "true",
        className: cls
      }, isRender || forceRender ? props.children : props.placeholder);
    }
  }]);

  return TabPane;
}(Component);

TabPane.propTypes = propTypes;
TabPane.defaultProps = defaultProps;
export default TabPane;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/TabPane.js